import { useState,useEffect } from "react";
import {connect} from "react-redux";
import { useParams } from "react-router-dom";
import Messages_Search_Followings_User from "./Messages_Search_Followings_User";

const Messages_Search_Followings = (props) => {
    const [followingIds,setFollowingIds] = useState([]);
    const params = useParams();

    useEffect(() => {
        fetch(`/follow/followingusers?q=${params.id}`)
        .then(res => res.json())
        .then(data => {
            setFollowingIds(data.filter(elem => !props.rooms_second_user_id_array.some(i => i.following_id === elem.following_id)))});
    },[])

    return(
        <div className={`messages_rooms messages_rooms_${props.color_background}`}>
            {
                followingIds.map(obj => {
                    return <Messages_Search_Followings_User key={obj.following_id} user_id={obj.following_id} />
                })
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        color_button: state.getColorButton.color_button,
        rooms_second_user_id_array: state.setRoomsSecondUserIdArray.rooms_second_user_id_array
    }
}
export default connect(mapStateToProps)(Messages_Search_Followings);